export default function dynamicImage(supported, image, webp) {
    return supported ? webp : image
}
